import React, { useContext } from "react";
import { Link } from "react-router-dom";
import commonContext from "../../context/common";

export default function BackContinueButton(props) {
    const {lead} = useContext(commonContext);
    return (
        <>
            <div className="flex flex-wrap flex-col-reverse sm:flex-row my-8 items-center w-full">
                <Link to={props.backPath}>
                    <a
                        className="back-btn blue-link-color mb-2 no-underline hover:underline hover:text-black openSans-SemiBold text-sm md:text-base lg:text-lg xl:text-lg transition-all text-center"
                        title="Back"
                    >
                        Back
                    </a>
                </Link>
                <button
                    className={"button-blue-bg button-blue mb-2 px-4 py-2 rounded text-base lg:text-lg xl:text-xl text-white text-center " + lead.loadingBtn}
                    title="Continue"
                >
                    Continue
                </button>
            </div>
        </>
    );
}
